import React from 'react';
import { toast } from 'sonner';
import { CalendarClock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useConfirm } from './ui/confirm';
import { Button } from './ui/button';
import { mensajeDeError } from '../lib/mensajeDeError';
import { ratoCorto } from '../lib/horaEspana';

/**
 * ACTIVAR LA FECHA DE UNA CUENTA DE PRUEBA (0.2 del encargo de Jesús, 02-11). La activa un
 * admin desde la ficha del cliente, a 0; luego la cuenta la mueve desde su pantalla
 * (`FechaDePrueba`). Sale solo donde el servidor dice que se puede (`fecha_de_prueba_posible`:
 * cliente de prueba y fuera de producción, `core/fecha_de_prueba`). Si ya está activa, lo dice.
 */
export default function ActivarFechaDePrueba({ usuario, alActivarla }) {
    const { api } = useAuth();
    const { confirm } = useConfirm();
    if (!usuario?.fecha_de_prueba_posible) return null;

    const minutos = usuario.minutos_por_delante;
    if (minutos !== undefined && minutos !== null) {
        return (
            <span className="inline-flex items-center text-sm text-sky-700 px-2" data-testid="fecha-de-prueba-activa">
                <CalendarClock className="w-4 h-4 mr-1" />
                Fecha de prueba activa: {minutos ? `${ratoCorto(minutos)} por delante` : 'va con la hora de verdad'}
            </span>
        );
    }

    const activar = async () => {
        if (!await confirm({
            title: `¿Activar la fecha de prueba de ${usuario.name || usuario.email}?`,
            description: 'Arriba de su pantalla le saldrá su fecha y hora, y desde ahí podrá adelantarlas horas, días o semanas para ver cada aviso en su momento. Solo va hacia delante: lo que haga en esas fechas se queda.',
            confirmLabel: 'Activar',
        })) return;
        try {
            await api.put(`/admin/users/${usuario.id}/fecha-de-prueba`, { minutos: 0 });
            toast.success('Fecha de prueba activada');
            alActivarla?.();
        } catch (e) {
            toast.error(mensajeDeError(e, 'No se pudo activar la fecha de prueba'));
        }
    };

    return (
        <Button onClick={activar} variant="outline" data-testid="activar-fecha-de-prueba"
            className="bg-transparent border-[#D6D2C9] text-[#1C1B19] hover:bg-[#F6F5F2] text-sm">
            <CalendarClock className="w-4 h-4 mr-1" /> Activar fecha de prueba
        </Button>
    );
}
